/**
 * 店舗スライダーと検索条件から /data/dai 等に送る halls を解決する。
 * currentHalls が空（全店）のときは検索時に指定した halls を使う。
 */
export const resolveUnitDataListFetchHalls = (
  currentHalls: string[],
  searchedHalls: string[] | undefined
): string[] | undefined =>
  currentHalls.length === 0 ? searchedHalls : currentHalls;
